const CREATION_THRESHOLD = 1000 * 3600 * 12; // 12 hours

export const isReturningClient = (client) => {
  if (!client || !client.created_at) {
    return false;
  }
  const timeSince = Date.now() - new Date(client.created_at).getTime();
  if (timeSince > CREATION_THRESHOLD) {
    return true;
  }
  return false;
};

export const bannedPhoneNumbers = () => {
  return ['9168268707', '9163801918'];
};

export const bannedEmails = () => {
  return ['destinymberches@gmail.com'];
};
